import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/shared/components/ui/dialog'
import { Button } from 'src/shared/components/ui/button'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const DeleteConfirmDialog = ({
  open,
  onOpenChange,
  title,
  description,
  onConfirm,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description: string
  onConfirm: () => void
}) => {
  const { t } = useLocalization()

  const handleConfirm = () => {
    onConfirm()
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription className="mt-2">{description}</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button onClick={() => onOpenChange(false)}>
            {t('Cancel', 'Avbryt')}
          </Button>

          <Button variant="destructive" onClick={handleConfirm}>
            {t('Delete', 'Ta bort')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
